<div id="voip-peer-general-information" *ngIf="voipPeer">
  <div class="map-summary-item-container">
    <span class="map-summary-item-field">Name:</span>
    <span class="map-summary-item-value" [title]="voipPeer.name">{{voipPeer.name}}</span>
  </div>

  <div class="map-summary-item-container">
    <span class="map-summary-item-field">Type:</span>
    <span class="map-summary-item-value" [title]="voipPeer.deviceType">{{voipPeer.deviceType}}</span>
  </div>

  <div *ngIf="voipPeer.cacProfileId">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">CAC Profile:</span>
      <span class="map-summary-item-value" [title]="voipPeer.cacProfileName">{{voipPeer.cacProfileName}}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">CAC State:</span>
      <span class="map-summary-item-value" [title]="voipPeer.cacState">{{voipPeer.cacState}}</span>
    </div>
  </div>

  <div class="map-summary-item-container" *ngIf="voipPeer.topologyGroups">
    <span class="map-summary-item-field">Resource Groups:</span>
    <span class="map-summary-item-value" [title]="voipPeer.topologyGroups">{{voipPeer.topologyGroups}}</span>
  </div>
</div>
